import React from 'react';

export const SideBarUpArrow = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd" opacity=".5">
        <path d="M3.53 3.53h16.94v16.94H3.53z" />
        <path stroke="#72706F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M15.388 13.694 12 10.306l-3.388 3.388" />
      </g>
    </svg>
  );
};

export default SideBarUpArrow;
